import React from 'react';
import PropTypes from 'prop-types';
import { LargeNavigationButtonBlock } from '../styles/blocks/LargeNavigationButtonBlock';

const LargeNavigationButton = props => {
  if (!props.image || !props.title || !props.url) {
    return false;
  }

  return (
    <LargeNavigationButtonBlock.Container to={props.url}>
      <LargeNavigationButtonBlock.Content to={props.url} image={props.image}>
        <LargeNavigationButtonBlock.Title>{props.title}</LargeNavigationButtonBlock.Title>
      </LargeNavigationButtonBlock.Content>
    </LargeNavigationButtonBlock.Container>
  );
};

LargeNavigationButton.defaultProps = {
  image: null,
  url: null,
  title: null
};

LargeNavigationButton.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string
};

export default LargeNavigationButton;



// WEBPACK FOOTER //
// ./src/components/LargeNavigationButton.js